import React, { useState, useEffect, useContext} from 'react';
import MUIDataTable from 'mui-datatables';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
    Card,
    Stack,
    Alert,
    Button,
    Container,
    Typography,
    MenuItem,  
    ListItemIcon, 
    ListItemText,
    AlertTitle
  } from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';  

import {api, reiniciarToken, consultaFornecedores, excluirFornecedores} from '../../services/api';
// context
import { AuthContext } from '../../contexts/auth'; 

import Page from '../../components/Page';
import Iconify from '../../components/Iconify';

export default function ConsultaFornecedor() {
  
  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);

  const getFornecedores = async () => {
    
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consultaFornecedores();
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      setData(response.data);
    }; 
  }

  useEffect(() => {
    getFornecedores();
  },[]) 

  const [status, setStatus] = useState({
    type: '',
    mensagem: ''
  }) 
  
  
  const excluirFornecedor = async (id) => {
    const response = await excluirFornecedores(id);

    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }else {
        setStatus({
          type: "erro",
          mensagem: response.mensagem
        })
      }
    }else {
      setStatus({
        type: "success",
        mensagem: response.data.mensagem
      })
      getFornecedores();
    };
  } 

  const columns = [{name: "Ação",
                    options: {
                      filter: false,
                      sort: false,
                      empty: true,
                      customBodyRenderLite: (dataIndex, rowIndex) =>  {
                        return (
                          <> 
                            <MenuItem onClick={() => excluirFornecedor(dados[dataIndex].id_fornecedor)} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:trash-2-outline" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Excluir" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>

                            <MenuItem component={RouterLink} to={`/fornecedor/editar/${dados[dataIndex].id_fornecedor}`} sx={{ color: 'text.secondary' }}>
                              <ListItemIcon>
                                  <Iconify icon="eva:edit-fill" width={24} height={24} />
                              </ListItemIcon>
                              <ListItemText primary="Alterar" primaryTypographyProps={{ variant: 'body2' }} />
                            </MenuItem>
                          </> 
                        );
                      }
                    }
                  }
                  ,{name:"id_fornecedor", label: "Código"} 
                  ,{name:"nome_fantasia", label: "Nome"}
                  ,{name:"razao_social", label: "Razão Social"}
                  ,{name:"endereco", label: "Endereço"}
                  ,{name:"numero", label: "Número"}
                  ,{name:"complemento", label: "Complemento"}
                  ,{name:"bairro", label: "Bairro"}
                  ,{name:"cidade", label: "Cidade"}
                  ,{name:"estado", label: "Estado"}
                  ,{name:"uf", label: "UF"}
                  ,{name:"cep", label: "CEP"}
                  ,{name:"tipo_pessoa", label: "Tipo Pessoa"}
                  ,{name:"cnpj_cpf", label: "CPF/CNPJ"}
                  ,{name:"inscricao_municipal", label: "Insc. Municipal"}
                  ,{name:"inscricao_estadual", label: "Insc. Estadual"}
                  ,{name:"email", label: "E-mail"}
                  ,{name:"contato", label: "Contato"}
                  ,{name:"telefone_celular", label: "Celular"}
                  ,{name:"telefone_fixo", label: "Telefone Fixo"}
                  ];

  const options = {
    filterType: "dropdown",
    tableBodyHeight: "100%",
    selectableRows: "none",
    responsive: "standard",
  };             
                    
  return (
    <Page title="Fornecedor">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Consulta de Fornecedores
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/fornecedor/cadastrar" startIcon={<Iconify icon="eva:plus-fill" />}>
              Novo Fornecedor
            </Button>
          </ThemeProvider>
        </Stack>
        <Card>
            <Stack spacing={3}>
              {status.type === 'erro' ? <Alert severity="error"><AlertTitle>Erro</AlertTitle>{status.mensagem}</Alert> : ""}
              {status.type === 'success' ? <Alert severity="success"><AlertTitle>Sucesso</AlertTitle>{status.mensagem}</Alert> : ""}
            </Stack > 
            <MUIDataTable
                data={Object.values(dados)}
                columns={columns}  
                options={options} 
            />
        </Card>
      </Container>  
    </Page>  
  );
}

